/**
 * Sweezy Custom Progress Bar for Youtube — animated YouTube scrubber skins
 *
 * Declares a single web-accessible-resource entry, `assets/images/progress_scrubbers/*`,
 * with no `use_dynamic_url` but scoped via `matches` to youtube.com only. The glob
 * expands to hundreds of concretely-named scrubber images at fixed URLs — conclusive
 * probes — but they are genuinely unreachable from any other origin, so only YouTube
 * can detect this extension.
 *
 * From anywhere else a negative proves nothing, hence `requiredOrigin`.
 *
 * Manifest verified against version 3.0.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bnjlijllccbbjdeiflmakhkijbdddflj';

export const sweezyProgressBar: ExtensionDefinition = {
  id: ID,
  name: 'Sweezy Custom Progress Bar for Youtube™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 70_000,
  requiredOrigin: 'https://www.youtube.com',
  notes:
    'Its one WAR globs the progress_scrubbers image folder, scoped to youtube.com with ' +
    'no dynamic URL, so only that origin can detect it — conclusive there, silent elsewhere.',
  signals: [
    {
      id: 'war-scrubber-default-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/images/progress_scrubbers/default.png — a fixed-URL scrubber image, ' +
        'but only exposed to youtube.com.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/images/progress_scrubbers/default.png'),
    },
    {
      id: 'war-scrubber-nyan-cat-png',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/images/progress_scrubbers/nyan-cat.png — a second concretely-named ' +
        'scrubber image, corroborating the identification.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/images/progress_scrubbers/nyan-cat.png'),
    },
  ],
};
